import styled from 'styled-components';

const Wrapper = styled.div`
  .help {
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    width: 100%;
    height: 100%;
    z-index: 1001;

    &__background {
      position: absolute;
      width: 100%;
      height: 100%;
      background: black;
      opacity: 0.5;
    }

    &__modal {
      position: absolute;
      background: white;
      padding: 20px;
      border-radius: 5px;
      margin-top: 50px;

      &__header {
        display: flex;
        align-items: center;
        justify-content: space-between;

        &__title {
          margin: 0;
          font-weight: 500;
        }

        &__close {
          background: none;
          border: none;
          padding: 0;
          opacity: 0.5;
          cursor: pointer;
          transition: all 300ms;

          &:hover {
            opacity: 1;
          }

          &__img {
            width: 20px;
          }
        }
      }

      &__tabs {
        display: flex;
        align-items: center;
        gap: 25px;
        margin: 20px 0;
        border-bottom: 2px solid #dbdbdbff;

        &__item {
          background: none;
          padding: 8px 0;
          margin-bottom: -2px;
          border: none;
          font-weight: 500;
          opacity: 0.7;
          border-bottom: 2px solid #dbdbdbff;
          cursor: pointer;
          transition: all 300ms;

          &--active {
            border-color: #cf4825ff;
            opacity: 1;
          }
        }
      }

      &__bodies {
        max-height: 50vh;
        max-width: 700px;
        margin-bottom: 20px;
        overflow-y: auto;

        &__item {
          &:not(.help__modal__bodies__item--active) {
            display: none;
          }
        }
      }

      &__buttons {
        display: flex;
        flex-direction: column;
        gap: 10px;

        &__button {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          color: black;
          padding: 8px 13px;
          border-radius: 5px;
          width: 100%;
          border: 1px solid black;
          background: none;
          text-decoration: none;
          cursor: pointer;
          transition: all 300ms;

          &:hover {
            background-color: #f3f3f3ff;
          }

          &__img {
            width: 20px;
          }
        }
      }
    }
  }
`;

const svgStyle = {
  width: 20
};

export { Wrapper, svgStyle };



// WEBPACK FOOTER //
// ./src/components/SearchHelpPopup/style.js